import { useEffect, useState } from 'react'
import { schoolService } from '@/services/schoolService'
import { useTranslation } from 'react-i18next'

export function SubdomainTest() {
  const [info, setInfo] = useState({
    hostname: '',
    isSubdomain: false,
    schoolName: '',
    fullUrl: '',
  })

  const { t } = useTranslation('school')

  useEffect(() => {
    // Get information about the current URL
    const hostname = window.location.hostname
    const isSubdomain = schoolService.isSubdomainUrl()
    const schoolName = schoolService.getCurrentSchoolFromSubdomain() || 'none'
    const fullUrl = window.location.href

    setInfo({
      hostname,
      isSubdomain,
      schoolName,
      fullUrl,
    })
  }, [])

  return (
    <div className="p-4 bg-gray-100 rounded-lg mb-4">
      <h2 className="text-lg font-bold mb-2">{t('schoolLandingPage.subdomainTest.title')}</h2>
      <div className="space-y-1 text-sm font-mono">
        <p>
          <span className="font-bold">{t('schoolLandingPage.subdomainTest.fields.hostname')}</span> {info.hostname}
        </p>
        <p>
          <span className="font-bold">{t('schoolLandingPage.subdomainTest.fields.isSubdomain')}</span>{' '}
          {info.isSubdomain ? t('schoolLandingPage.subdomainTest.values.yes') : t('schoolLandingPage.subdomainTest.values.no')}
        </p>
        <p>
          <span className="font-bold">{t('schoolLandingPage.subdomainTest.fields.schoolName')}</span>{' '}
          {info.schoolName === 'none' ? t('schoolLandingPage.subdomainTest.values.none') : info.schoolName}
        </p>
        <p>
          <span className="font-bold">{t('schoolLandingPage.subdomainTest.fields.fullUrl')}</span> {info.fullUrl}
        </p>
      </div>
    </div>
  )
}
